module.exports = __webpack_public_path__ + "img/02-images-01.a73374a9.png";